/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Absence_DetailInputs */

const es_tools_legajox_absence_detail = /** @type {(inputs: Tools_Legajox_Absence_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando detalle de ausencia en Legajox...`)
};

const en_tools_legajox_absence_detail = /** @type {(inputs: Tools_Legajox_Absence_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox absence detail...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox absence detail..." |
*
* @param {Tools_Legajox_Absence_DetailInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_absence_detail = /** @type {((inputs?: Tools_Legajox_Absence_DetailInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Absence_DetailInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_absence_detail(inputs)
	return en_tools_legajox_absence_detail(inputs)
});
export { tools_legajox_absence_detail as "tools.legajox.absence_detail" }